import { Column } from "@tanstack/react-table";
import { LensIcon } from "assets";
import { CustomTooltip } from "components";
import { useEffect, useState } from "react";

export const Filter: React.FC<{
  column: Column<Record<string, unknown>, unknown>;
}> = ({ column }) => {
  const columnFilterValue = column.getFilterValue();

  return (
    <DebouncedInput
      type="text"
      value={(columnFilterValue ?? "") as string}
      onChange={(value) => column.setFilterValue(value)}
      placeholder={`Contains text...`}
    />
  );
};

export function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number;
  onChange: (value: string | number) => void;
  debounce?: number;
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange">) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value]);

  return (
    <div className="relative max-w-fit">
      <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
        <LensIcon />
      </div>
      <CustomTooltip title="Search column" placement="right">
      <input
        type="search"
        id="default-search"
        {...props}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="block p-1 ps-7 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none focus:ring-0"
        required
      />
      </CustomTooltip>
    </div>
  );
}
